// import React, { useState, useRef, useEffect } from "react";
// import { Link, useNavigate, NavLink } from "react-router-dom";
// import logo from "../../asstes/Brandimg/EAC_logo.png";
// import "./Navbar.css";
// import Search from "./Search";

// const Navbar = () => {
//   const navigate = useNavigate();
//   const [user, setUser] = useState(() => {
//     const storedUser = localStorage.getItem("user");
//     return storedUser ? JSON.parse(storedUser) : null;
//   });
//   const [menuOpen, setMenuOpen] = useState(false);

//   const [showLogout, setShowLogout] = useState(false);
//   const dropdownRef = useRef(null);

//   useEffect(() => {
//     const checkUser = () => {
//       const storedUser = localStorage.getItem("user");
//       setUser(storedUser ? JSON.parse(storedUser) : null);
//     };

//     checkUser();

//     window.addEventListener("storage", checkUser);
//     window.addEventListener("userChanged", checkUser);

//     return () => {
//       window.removeEventListener("storage", checkUser);
//       window.removeEventListener("userChanged", checkUser);
//     };
//   }, []);

//   const handleLogout = () => {
//     localStorage.removeItem("user");
//     setUser(null);
//     setShowLogout(false);

//     // SPA navigation without query params or hash
//     navigate("/login", { replace: true });
//     window.history.replaceState({}, "", "/login"); // ✅ clears any leftover query params
//   };

//   // Detect click outside
//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setShowLogout(false);
//       }
//     }

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [dropdownRef]);

//   const getAvatarLetter = () => {
//     if (!user) return "";
//     const name = user.displayName || user.fname || user.email || "";
//     return name.charAt(0).toUpperCase();
//   };

//   const isAdmin = user?.userType === "admin";

//   return (
//     <div className="container navbar-wrapper">
//       <div className="row d-flex justify-content-center">
//         <nav className="navbar navbar-expand-md navbar-light navbar-container px-4 py-2">
//           <button
//             className="navbar-toggler border-0"
//             type="button"
//             data-bs-toggle="collapse"
//             data-bs-target="#mainNavbar"
//             aria-controls="mainNavbar"
//             aria-expanded={menuOpen ? "true" : "false"}
//             aria-label="Toggle navigation"
//             onClick={() => setMenuOpen(!menuOpen)}
//           >
//             {menuOpen ? (
//               <i className="bi bi-x-lg fs-2"></i> // ❌ close icon
//             ) : (
//               <i className="bi bi-list fs-2"></i> // ☰ hamburger icon
//             )}
//           </button>
//           {/* Brand Logo */}
//           <Link className="navbar-brand d-flex align-items-center" to="/">
//             <img src={logo} alt="Logo" className="mt-3" />
//           </Link>

//           {/* Hamburger Button */}

//           {/* Collapsible Links */}
//           <div className="collapse navbar-collapse" id="mainNavbar">
//             <div className="mx-auto d-flex flex-column flex-md-row align-items-center gap-md-4">
//               <NavLink
//                 className={({ isActive }) =>
//                   isActive ? "active nav-link" : "nav-link"
//                 }
//                 to="/"
//               >
//                 Home
//               </NavLink>
//               <NavLink
//                 className={({ isActive }) =>
//                   isActive ? "active nav-link" : "nav-link"
//                 }
//                 to="/services"
//               >
//                 Services
//               </NavLink>
//               <NavLink
//                 className={({ isActive }) =>
//                   isActive ? "active nav-link" : "nav-link"
//                 }
//                 to="/courses"
//               >
//                 Courses
//               </NavLink>

//               <NavLink
//                 className={({ isActive }) =>
//                   isActive ? "active nav-link" : "nav-link"
//                 }
//                 to="/faq"
//               >
//                 FAQ
//               </NavLink>
//               <NavLink
//                 className={({ isActive }) =>
//                   isActive ? "active nav-link" : "nav-link"
//                 }
//                 to="/contact"
//               >
//                 Contact Us
//               </NavLink>
//               <NavLink
//                 className={({ isActive }) =>
//                   isActive ? "active nav-link" : "nav-link"
//                 }
//                 to="/addtocart"
//               >
//                 View Cart
//               </NavLink>
//             </div>
//             <Search />
//           </div>

//           {/* 🔹 Avatar / Login buttons ALWAYS visible outside collapse */}
//           <div className="navbar-user-section d-flex align-items-center ms-auto">
//             {user ? (
//               <div className="position-relative" ref={dropdownRef}>
//                 <div
//                   className="avatar-circle"
//                   onClick={() => setShowLogout(!showLogout)}
//                 >
//                   {getAvatarLetter()}
//                 </div>

//                 {showLogout && (
//                   <div className="profile-dropdown shadow p-3 rounded">
//                     <div className="d-flex align-items-center mb-2">
//                       <div>
//                         <strong>{user.fname || "User"}</strong>
//                         <p className="small text-muted mb-0">{user.email}</p>
//                       </div>
//                     </div>
//                     <hr className="my-2" />
//                     <Link
//                       to="/profile"
//                       className="d-block mb-2 text-decoration-none text-dark"
//                       onClick={() => setShowLogout(false)}
//                     >
//                       <i className="bi bi-person me-2"></i> View Profile
//                     </Link>

//                     <hr className="my-2" />
//                     <Link
//                       to="/myinterests"
//                       className="d-block mb-2 text-decoration-none text-dark"
//                     >
//                       <i className="bi bi-collection me-2"></i>
//                       My Courses
//                     </Link>

//                     {/* ✅ Admin Section Only */}
//                     {isAdmin && (
//                       <>
//                         <hr className="my-2" />
//                         <div className="fw-bold small mb-2">Admin Panel</div>
//                         <Link
//                           to="/adminpanel"
//                           className="d-block mb-2 text-decoration-none text-dark"
//                           onClick={() => setShowLogout(false)}
//                         >
//                           <i className="bi bi-people me-2"></i> User Report
//                         </Link>
//                       </>
//                     )}

//                     <hr className="my-2" />

//                     <button
//                       onClick={handleLogout}
//                       className="custom-logout-btn w-100 border-0"
//                     >
//                       Logout
//                     </button>
//                   </div>
//                 )}
//               </div>
//             ) : (
//               <>
//                 <Link to="/login">
//                   <button className="custom-btn border-1">Login </button>
//                 </Link>
//                 {/* <Link to="/register">
//                   <button className="custom-register-btn border-0">
//                     Sign Up
//                   </button>
//                 </Link> */}
//               </>
//             )}
//           </div>
//         </nav>
//       </div>
//     </div>
//   );
// };

// export default Navbar;

import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate, NavLink } from "react-router-dom";
import logo from "../../asstes/Brandimg/EAC_logo.png";
import "./Navbar.css";
import Search from "./Search";

const Navbar = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem("user");
    return storedUser ? JSON.parse(storedUser) : null;
  });
  const [menuOpen, setMenuOpen] = useState(false);

  const [showLogout, setShowLogout] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const checkUser = () => {
      const storedUser = localStorage.getItem("user");
      setUser(storedUser ? JSON.parse(storedUser) : null);
    };

    checkUser();

    window.addEventListener("storage", checkUser);
    window.addEventListener("userChanged", checkUser);

    return () => {
      window.removeEventListener("storage", checkUser);
      window.removeEventListener("userChanged", checkUser);
    };
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("user");
    setUser(null);
    setShowLogout(false);

    // SPA navigation without query params or hash
    navigate("/login", { replace: true });
    window.history.replaceState({}, "", "/login"); // ✅ clears any leftover query params
  };
  useEffect(() => {
    const navbar = document.getElementById("mainNavbar");

    const handleClose = () => setMenuOpen(false);

    navbar?.addEventListener("hidden.bs.collapse", handleClose);

    return () => {
      navbar?.removeEventListener("hidden.bs.collapse", handleClose);
    };
  }, []);

  // Detect click outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowLogout(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  const getAvatarLetter = () => {
    if (!user) return "";
    const name = user.displayName || user.fname || user.email || "";
    return name.charAt(0).toUpperCase();
  };

  const isAdmin = user?.userType === "admin";

  return (
    <div className="container navbar-wrapper">
      <div className="row d-flex justify-content-center">
        <nav className="navbar navbar-expand-xl navbar-light navbar-container px-4 py-2">
          <button
            className="navbar-toggler border-0"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#mainNavbar"
            aria-controls="mainNavbar"
            aria-expanded={menuOpen}
            aria-label="Toggle navigation"
            onClick={() => setMenuOpen((prev) => !prev)}
          >
            <i className={`bi ${menuOpen ? "bi-x-lg" : "bi-list"} fs-2`}></i>
          </button>
          {/* Brand Logo */}
          <Link className="navbar-brand d-flex align-items-center" to="/">
            <img
              src={logo}
              alt="Logo"
              className="me-2"
            />
          </Link>

          {/* Hamburger Button */}

          {/* Collapsible Links */}
          <div className="collapse navbar-collapse" id="mainNavbar">
            <div className="mx-auto d-flex flex-column flex-md-row align-items-center gap-md-4">
              <NavLink
                className={({ isActive }) =>
                  isActive ? "active nav-link" : "nav-link"
                }
                to="/"
              >
                Home
              </NavLink>
                <NavLink
                className={({ isActive }) =>
                  isActive ? "active nav-link" : "nav-link"
                }
                to="/services"
              >
                Services
              </NavLink>
              <NavLink
                className={({ isActive }) =>
                  isActive ? "active nav-link" : "nav-link"
                }
                to="/courses"
              >
                Courses
              </NavLink>
              <NavLink
                className={({ isActive }) =>
                  isActive ? "active nav-link" : "nav-link"
                }
                to="/faq"
              >
                FAQ
              </NavLink>
              <NavLink
                className={({ isActive }) =>
                  isActive ? "active nav-link" : "nav-link"
                }
                to="/contact"
              >
                Contact Us
              </NavLink>
              <NavLink
                className={({ isActive }) =>
                  isActive ? "active nav-link" : "nav-link"
                }
                to="/addtocart"
              >
                View Cart
              </NavLink>
            </div>
            <Search />
          </div>

          {/* 🔹 Avatar / Login buttons ALWAYS visible outside collapse */}
          <div className="navbar-user-section d-flex align-items-center ms-auto">
            {user ? (
              <div className="position-relative" ref={dropdownRef}>
                <div
                  className="avatar-circle"
                  onClick={() => setShowLogout(!showLogout)}
                >
                  {getAvatarLetter()}
                </div>

                {showLogout && (
                  <div className="profile-dropdown shadow p-3 rounded">
                    <div className="d-flex align-items-center mb-2">
                      <div>
                        <strong>{user.fname || "User"}</strong>
                        <p className="small text-muted mb-0">{user.email}</p>
                      </div>
                    </div>
                    <hr className="my-2" />
                    <Link
                      to="/profile"
                      className="d-block mb-2 text-decoration-none text-dark"
                      onClick={() => setShowLogout(false)}
                    >
                      <i className="bi bi-person me-2"></i> View Profile
                    </Link>

                    <hr className="my-2" />
                    <Link
                      to="/myinterests"
                      className="d-block mb-2 text-decoration-none text-dark"
                    >
                      <i className="bi bi-collection me-2"></i>
                      My Courses
                    </Link>

                    {/* ✅ Admin Section Only */}
                    {isAdmin && (
                      <>
                        <hr className="my-2" />
                        <div className="fw-bold small mb-2">Admin Panel</div>
                        <Link
                          to="/adminpanel"
                          className="d-block mb-2 text-decoration-none text-dark"
                          onClick={() => setShowLogout(false)}
                        >
                          <i className="bi bi-people me-2"></i> User Report
                        </Link>
                      </>
                    )}

                    <hr className="my-2" />

                    <button
                      onClick={handleLogout}
                      className="custom-logout-btn w-100 border-0"
                    >
                      Logout
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <>
                <Link to="/login">
                  <button className="custom-btn border-1">Login </button>
                </Link>
                {/* <Link to="/register">
                  <button className="custom-register-btn border-0">
                    Sign Up
                  </button>
                </Link> */}
              </>
            )}
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Navbar;
